import React from 'react';
import { Crown, CheckCircle2 } from 'lucide-react';
export function UpsellSection() {
  const modules = [{
    title: 'MÓDULO 1 y 2 — Matrices de Planificación Anual',
    subtitle: 'Para todos los grados de Primaria y Secundaria',
    highlight: 'Solo completás los campos en amarillo y poné tu nombre arriba.'
  }, {
    title: 'MÓDULO 3 — El Diccionario de Informes de Boletín',
    subtitle: '150 frases técnicas categorizadas por nivel de desempeño',
    highlight: 'Copiás la frase que corresponde. Pegás en el boletín. Listo.'
  }, {
    title: 'MÓDULO 4 — Rúbricas de Evaluación por Capacidades',
    subtitle: 'Listas para imprimir y llevar al patio',
    highlight: 'Las imprimís, las llevás al patio y evaluás mientras observás.'
  }, {
    title: 'MÓDULO 5 — Modelos de Proyectos Institucionales',
    subtitle: 'Para campamentos, salidas y torneos',
    highlight: 'Los completás con los datos de tu institución y los presentás directamente.'
  }, {
    title: 'MÓDULO 6 — Banco de Frases para Actas y Comunicados',
    subtitle: 'Textos formales listos para documentos oficiales',
    highlight: 'Todo redactado en el lenguaje que el sistema espera ver.'
  }];
  return <section className="bg-white py-20 px-4" data-id="element-131">
      <div className="max-w-4xl mx-auto" data-id="element-132">
        <div className="bg-[#0B1A2E] text-white rounded-2xl p-8 md:p-10 mb-16 shadow-xl border-b-4 border-[#D4A843]" data-id="element-133">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 text-[#F0C14B]" data-id="element-134">
            Ya tenés el sistema para el patio. ¿Pero qué pasa con la montaña de
            papel que te pide la escuela?
          </h2>
          <div className="text-lg text-gray-300 space-y-4 text-center mb-8" data-id="element-135">
            <p data-id="element-136">
              Planificaciones anuales, informes de boletín, rúbricas,
              proyectos...
            </p>
            <p data-id="element-137">
              Escribir todo eso desde cero le consume al profe promedio entre{' '}
              <strong className="text-white" data-id="element-138">40 y 70 horas al año.</strong>
            </p>
          </div>
          <p className="text-xl md:text-2xl font-bold text-center text-[#F0C14B]" data-id="element-139">
            ¿Y si todo ese trabajo ya estuviera hecho?
          </p>
        </div>

        <div className="text-center mb-12" data-id="element-140">
          <div className="inline-flex items-center justify-center bg-[#D4A843]/10 text-[#D4A843] px-6 py-2 rounded-full mb-6" data-id="element-141">
            <Crown className="w-6 h-6 mr-2" data-id="element-142" />
            <span className="font-bold tracking-widest uppercase" data-id="element-143">
              Presentación Exclusiva
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#0B1A2E] mb-4" data-id="element-144">
            TOMO GOLD: LA BÓVEDA DE PLANIFICACIONES
          </h2>
          <p className="text-2xl italic text-gray-600 font-medium" data-id="element-145">
            "Copiar, Pegar y Presentar — Tu Carpeta Anual Lista en 15 Minutos"
          </p>
        </div>

        <div className="bg-gradient-to-r from-[#D4A843] to-[#F0C14B] p-1 rounded-2xl mb-16 shadow-xl" data-id="element-146">
          <div className="bg-white p-8 rounded-xl text-center" data-id="element-147">
            <p className="text-xl md:text-2xl font-bold text-[#0B1A2E] mb-2" data-id="element-148">
              💡 Este no es un tomo más del sistema.
            </p>
            <p className="text-lg md:text-xl text-gray-700" data-id="element-149">
              Es el tomo que elimina para siempre el trabajo burocrático más
              pesado del año.
            </p>
            <p className="mt-4 text-gray-600" data-id="element-150">
              El Tomo Gold es una biblioteca completa de textos profesionales
              listos para que los copies, los adaptes mínimamente con tu nombre
              y los presentes con total confianza.{' '}
              <strong className="text-gray-900" data-id="element-151">
                No es para leer. Es para usar.
              </strong>
            </p>
          </div>
        </div>

        <h3 className="text-3xl font-bold text-center text-[#0B1A2E] mb-10" data-id="element-152">
          ¿Qué tiene adentro el Tomo Gold?
        </h3>

        <div className="space-y-4 mb-16" data-id="element-153">
          {modules.map((mod, idx) => <div key={idx} className="border border-gray-200 rounded-xl p-5 hover:border-[#D4A843] transition-colors shadow-sm flex flex-col md:flex-row md:items-center gap-4 bg-gray-50" data-id="element-154">
              <div className="flex-1" data-id="element-155">
                <h4 className="text-lg font-bold text-[#0B1A2E]" data-id="element-156">
                  {mod.title}
                </h4>
                <p className="text-[#D4A843] font-semibold text-sm" data-id="element-157">
                  {mod.subtitle}
                </p>
              </div>
              <div className="flex-1 bg-white p-3 rounded-lg border border-gray-100" data-id="element-158">
                <p className="font-medium text-gray-800 text-sm flex items-start" data-id="element-159">
                  <CheckCircle2 className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-160" />
                  {mod.highlight}
                </p>
              </div>
            </div>)}
        </div>

        <div className="bg-[#0B1A2E] text-white rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-161">
          <h3 className="text-2xl md:text-3xl font-bold text-center text-[#F0C14B] mb-8" data-id="element-162">
            ¿Por qué vale $10.000 ARS adicionales?
          </h3>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-163">
            <div className="space-y-4" data-id="element-164">
              <h4 className="text-xl font-bold text-red-400 border-b border-red-400/30 pb-2" data-id="element-165">
                Sin el Tomo Gold
              </h4>
              <ul className="space-y-3 text-gray-300" data-id="element-166">
                <li data-id="element-167">❌ 40-70 horas al año escribiendo documentos.</li>
                <li data-id="element-168">❌ Fundamentaciones inventadas a las 11PM.</li>
                <li data-id="element-169">❌ Frases genéricas en el boletín.</li>
                <li data-id="element-170">❌ Miedo a que el inspector pida la carpeta.</li>
                <li data-id="element-171">❌ Domingos frente a la pantalla en blanco.</li>
              </ul>
            </div>
            <div className="space-y-4" data-id="element-172">
              <h4 className="text-xl font-bold text-green-400 border-b border-green-400/30 pb-2" data-id="element-173">
                Con el Tomo Gold
              </h4>
              <ul className="space-y-3 text-gray-300" data-id="element-174">
                <li data-id="element-175">✅ 1 hora al año completando campos.</li>
                <li data-id="element-176">✅ Textos profesionales listos para copiar.</li>
                <li data-id="element-177">✅ 150 frases técnicas por nivel de desempeño.</li>
                <li data-id="element-178">✅ Carpeta lista antes de que la pida.</li>
                <li data-id="element-179">✅ Domingos libres para lo que importa.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}